import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/video-style-transfer"
    exact
    path="/consumer/features/video-style-transfer"
    component={AsyncPage}
  />,
];
